<template>
  <v-form v-model="valid" ref="mainForm">
    <subheadline code="titre-etape-2.1"></subheadline>

    <opq-catalogue code="limites" v-model="sasAutoInspection1.tiensCompteDesLimites" :live="liveSasAutoInspection1(15415)"></opq-catalogue>

    <opq-catalogue code="respect" v-model="sasAutoInspection1.adopteAttitudeRespecteuse" :live="liveSasAutoInspection1(15416)"></opq-catalogue>

    <opq-catalogue
      code="secret-professionnel"
      v-model="sasAutoInspection1.respecteSecretProEtReglesConfidentialite"
      :live="liveSasAutoInspection1(15417)"
    ></opq-catalogue>

    <opq-catalogue
      code="renseignements"
      v-model="sasAutoInspection1.transmetsRenseignementsJustes"
      :live="liveSasAutoInspection1(15418)"
    ></opq-catalogue>

    <opq-memo code="renseignements_details" v-model="sasAutoInspection1.renseignementsDetails" :live="liveSasAutoInspection1(15419)"></opq-memo>

    <opq-catalogue code="consentement" v-model="sasAutoInspection1.appliqueReglesConsentement" :live="liveSasAutoInspection1(15420)"></opq-catalogue>

    <opq-memo code="consentement_details" v-model="sasAutoInspection1.consentementDetails" :live="liveSasAutoInspection1(15421)"></opq-memo>

    <opq-catalogue code="integrite" v-model="sasAutoInspection1.respectePrincipesDIntegrite" :live="liveSasAutoInspection1(15422)"></opq-catalogue>

    <opq-catalogue
      code="pratique-professionnelle"
      v-model="sasAutoInspection1.fondePratiqueProfessionnellePrincipesScientifiquesEtProfessionnels"
      :live="liveSasAutoInspection1(15423)"
    ></opq-catalogue>

    <opq-catalogue
      code="equilibre-travail-vie"
      v-model="sasAutoInspection1.equilibreTravailViePersonnelle"
      :live="liveSasAutoInspection1(15424)"
    ></opq-catalogue>

    <opq-catalogue
      code="conflit-interets"
      v-model="sasAutoInspection1.attentionConflitDInterets"
      :live="liveSasAutoInspection1(15425)"
    ></opq-catalogue>

    <opq-catalogue code="promotion-sante" v-model="sasAutoInspection1.principesPromotionSante" :live="liveSasAutoInspection1(15426)"></opq-catalogue>

    <opq-catalogue code="respect-lois" v-model="sasAutoInspection1.respecteLoisEtReglements" :live="liveSasAutoInspection1(15427)"></opq-catalogue>

    <opq-catalogue
      code="honoraires-justes"
      v-model="sasAutoInspection1.honorairesJustesEtRaisonnables"
      :live="liveSasAutoInspection1(15428)"
    ></opq-catalogue>

    <opq-catalogue code="recus-conformes" v-model="sasAutoInspection1.recusConformes" :live="liveSasAutoInspection1(15429)"></opq-catalogue>

    <opq-catalogue code="personne-ressource" v-model="sasAutoInspection1.personneRessource" :live="liveSasAutoInspection1(15430)"></opq-catalogue>

    <opq-memo code="personne-ressource-ex" v-model="sasAutoInspection1.personneRessourceExemple" :live="liveSasAutoInspection1(15431)"></opq-memo>

    <opq-memo code="deontologie-exemple" v-model="sasAutoInspection1.deontologieExemple" :live="liveSasAutoInspection1(15434)"></opq-memo>

    <opq-memo code="deontologie-details" v-model="sasAutoInspection1.deontologieDetails" :live="liveSasAutoInspection1(15435)"></opq-memo>

    <subheadline code="titre-etape-2.2"></subheadline>

    <opq-catalogue code="approche-client" v-model="sasAutoInspection1.approcheClient" :live="liveSasAutoInspection1(15437)"></opq-catalogue>

    <opq-catalogue code="empathie" v-model="sasAutoInspection1.empathieEtRespect" :live="liveSasAutoInspection1(15438)"></opq-catalogue>

    <opq-catalogue
      code="presence-attentive"
      v-model="sasAutoInspection1.presenceAttentiveEtSensible"
      :live="liveSasAutoInspection1(15439)"
    ></opq-catalogue>

    <opq-catalogue code="dignite" v-model="sasAutoInspection1.respectDigniteAutonomie" :live="liveSasAutoInspection1(15440)"></opq-catalogue>

    <opq-catalogue code="preoccupations" v-model="sasAutoInspection1.preoccupationsEtAttentes" :live="liveSasAutoInspection1(15441)"></opq-catalogue>

    <opq-catalogue
      code="caracteristiques-client"
      v-model="sasAutoInspection1.caracteristiquesClients"
      :live="liveSasAutoInspection1(15442)"
    ></opq-catalogue>

    <opq-catalogue
      code="strategie-communication"
      v-model="sasAutoInspection1.adapteStrategieCommunication"
      :live="liveSasAutoInspection1(15443)"
    ></opq-catalogue>

    <opq-catalogue code="soutien-efficace" v-model="sasAutoInspection1.apporteSoutienEfficace" :live="liveSasAutoInspection1(15444)"></opq-catalogue>

    <opq-catalogue code="autonomisation" v-model="sasAutoInspection1.soutienAutonomisation" :live="liveSasAutoInspection1(15445)"></opq-catalogue>

    <opq-catalogue
      code="distance-professionnelle"
      v-model="sasAutoInspection1.distanceProfessionnelle"
      :live="liveSasAutoInspection1(15446)"
    ></opq-catalogue>

    <opq-memo code="clienteles-defi" v-model="sasAutoInspection1.clientelesDefi" :live="liveSasAutoInspection1(15447)"></opq-memo>

    <opq-memo code="clienteles-defi-moyens" v-model="sasAutoInspection1.clientelesDefiMoyens" :live="liveSasAutoInspection1(15448)"></opq-memo>

    <subheadline code="titre-etape-2.3"></subheadline>

    <opq-catalogue
      code="roles-responsabilites"
      v-model="sasAutoInspection2.rolesEtResponsabilites"
      :live="liveSasAutoInspection2(15503)"
    ></opq-catalogue>

    <opq-catalogue code="apport-psy" v-model="sasAutoInspection2.apportPsy" :live="liveSasAutoInspection2(15504)"></opq-catalogue>

    <opq-catalogue code="information-utile" v-model="sasAutoInspection2.informationUtile" :live="liveSasAutoInspection2(15505)"></opq-catalogue>

    <opq-catalogue
      code="information-transmise"
      v-model="sasAutoInspection2.informationTransmise"
      :live="liveSasAutoInspection2(15506)"
    ></opq-catalogue>

    <opq-catalogue code="information-recue" v-model="sasAutoInspection2.informationRecue" :live="liveSasAutoInspection2(15507)"></opq-catalogue>

    <opq-catalogue
      code="planification-services-offerts"
      v-model="sasAutoInspection2.planificationServicesOfferts"
      :live="liveSasAutoInspection2(15508)"
    ></opq-catalogue>

    <opq-catalogue
      code="amelioration-services-offerts"
      v-model="sasAutoInspection2.ameliorationServicesOfferts"
      :live="liveSasAutoInspection2(15509)"
    ></opq-catalogue>

    <opq-catalogue code="discussion-pairs" v-model="sasAutoInspection2.discussionPairs" :live="liveSasAutoInspection2(15510)"></opq-catalogue>

    <opq-catalogue
      code="ouverture-suggestions"
      v-model="sasAutoInspection2.ouvertureSuggestions"
      :live="liveSasAutoInspection2(15511)"
    ></opq-catalogue>

    <opq-memo code="engagement-details" v-model="sasAutoInspection2.engagementDetails" :live="liveSasAutoInspection2(15512)"></opq-memo>

    <subheadline code="titre-etape-2.4"></subheadline>

    <opq-catalogue code="dossier-client" v-model="sasAutoInspection2.dossierClient" :live="liveSasAutoInspection2(15513)"></opq-catalogue>

    <opq-catalogue code="dossier-conservation" v-model="sasAutoInspection2.dossierConservation" :live="liveSasAutoInspection2(15514)"></opq-catalogue>

    <opq-catalogue
      code="dossier-confidentialite"
      v-model="sasAutoInspection2.dossierConfidentialite"
      :live="liveSasAutoInspection2(15515)"
    ></opq-catalogue>

    <opq-catalogue code="dossier-date" v-model="sasAutoInspection2.dossierInscriptionDate" :live="liveSasAutoInspection2(15516)"></opq-catalogue>

    <opq-catalogue code="donnees-nominatives" v-model="sasAutoInspection2.donneesNominatives" :live="liveSasAutoInspection2(15517)"></opq-catalogue>

    <opq-catalogue code="description-motifs" v-model="sasAutoInspection2.descriptionMotifs" :live="liveSasAutoInspection2(15518)"></opq-catalogue>

    <opq-catalogue
      code="conclusions-evaluation-initiale"
      v-model="sasAutoInspection2.conclusionsEvaluationInitiale"
      :live="liveSasAutoInspection2(15519)"
    ></opq-catalogue>

    <opq-catalogue code="notations-evolution" v-model="sasAutoInspection2.notationsEvolution" :live="liveSasAutoInspection2(15520)"></opq-catalogue>

    <opq-catalogue
      code="document-transmission"
      v-model="sasAutoInspection2.documentTransmission"
      :live="liveSasAutoInspection2(15521)"
    ></opq-catalogue>

    <opq-catalogue code="copie-contrat" v-model="sasAutoInspection2.copieContrat" :live="liveSasAutoInspection2(15522)"></opq-catalogue>

    <opq-catalogue
      code="signature-information"
      v-model="sasAutoInspection2.signatureInformation"
      :live="liveSasAutoInspection2(15523)"
    ></opq-catalogue>

    <opq-catalogue code="dossier-unique" v-model="sasAutoInspection2.dossierUnique" :live="liveSasAutoInspection2(15524)"></opq-catalogue>

    <opq-catalogue code="donnee-brute" v-model="sasAutoInspection2.donneeBrute" :live="liveSasAutoInspection2(15525)"></opq-catalogue>

    <opq-catalogue
      code="dossier-conservation-lieusur"
      v-model="sasAutoInspection2.dossierConservationLieuSur"
      :live="liveSasAutoInspection2(15526)"
    ></opq-catalogue>

    <opq-catalogue code="membre-lssss" v-model="sasAutoInspection2.membreLssss" :live="liveSasAutoInspection2(15541)"></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-conservation-5ans"
      v-model="sasAutoInspection2.dossierConservation5ans"
      :live="liveSasAutoInspection2(15528)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-destruction"
      v-model="sasAutoInspection2.dossierDestruction"
      :live="liveSasAutoInspection2(15529)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-transmission-delai"
      v-model="sasAutoInspection2.dossierTransmissionDelai"
      :live="liveSasAutoInspection2(15530)"
    ></opq-catalogue>

    <opq-catalogue
      :opq-if="estNonMembreLssss"
      code="dossier-transmission-formulaire"
      v-model="sasAutoInspection2.dossierTransmissionFormulaire"
      :live="liveSasAutoInspection2(15531)"
    ></opq-catalogue>

    <opq-catalogue
      code="dossier-exercice-societe"
      v-model="sasAutoInspection2.dossierExerciceSociete"
      :live="liveSasAutoInspection2(15533)"
    ></opq-catalogue>

    <opq-catalogue
      code="transmission-donnees-brutes"
      v-model="sasAutoInspection2.transmissionDonneesBrutes"
      :live="liveSasAutoInspection2(15534)"
    ></opq-catalogue>

    <div class="mb-3">
      <ressource code="desc-redaction-rapports"></ressource>
    </div>

    <opq-catalogue code="mandat-evaluation" v-model="sasAutoInspection2.mandatEvaluation" :live="liveSasAutoInspection2(15535)"></opq-catalogue>

    <opq-catalogue
      code="methodologie-evaluation"
      v-model="sasAutoInspection2.methodologieEvaluation"
      :live="liveSasAutoInspection2(15536)"
    ></opq-catalogue>

    <opq-catalogue
      code="conclusions-evaluation"
      v-model="sasAutoInspection2.conclusionsEvaluation"
      :live="liveSasAutoInspection2(15537)"
    ></opq-catalogue>

    <opq-catalogue
      code="guide-bonnes-pratiques"
      v-model="sasAutoInspection2.guideBonnesPratiques"
      :live="liveSasAutoInspection2(15538)"
    ></opq-catalogue>

    <opq-catalogue
      code="date-rapport-evaluation"
      v-model="sasAutoInspection2.rapportEvaluationInscriptionDate"
      :live="liveSasAutoInspection2(15539)"
    ></opq-catalogue>

    <opq-memo code="delai-rapports" v-model="sasAutoInspection2.delaiRapports" :live="liveSasAutoInspection2(15540)"></opq-memo>

    <opq-memo
      code="delai-rapports-commentaire"
      v-model="sasAutoInspection2.delaiRapportsCommentaire"
      :live="liveSasAutoInspection2(15553)"
    ></opq-memo>

    <subheadline code="titre-etape-2.5"></subheadline>

    <opq-catalogue
      code="cabinet-professionnel"
      v-model="sasAutoInspection2.cabinetProfessionnel"
      :live="liveSasAutoInspection2(15543)"
    ></opq-catalogue>

    <opq-catalogue code="cabinet-confidentiel" v-model="sasAutoInspection2.cabinetConfidentiel" :live="liveSasAutoInspection2(15544)"></opq-catalogue>

    <opq-catalogue
      code="cabinet-salle-attente"
      v-model="sasAutoInspection2.cabinetSalleDAttente"
      :live="liveSasAutoInspection2(15546)"
    ></opq-catalogue>

    <opq-catalogue
      code="cabinet-permis-affiche"
      v-model="sasAutoInspection2.cabinetPermisAffiche"
      :live="liveSasAutoInspection2(15547)"
    ></opq-catalogue>

    <opq-catalogue
      code="cabinet-documents-originaux"
      v-model="sasAutoInspection2.cabinetDocumentsOriginaux"
      :live="liveSasAutoInspection2(15548)"
    ></opq-catalogue>

    <opq-catalogue
      code="cabinet-adresse-ordre"
      v-model="sasAutoInspection2.cabinetAdresseOrdre"
      :live="liveSasAutoInspection2(15554)"
    ></opq-catalogue>

    <opq-catalogue
      code="cabinet-diplome-affiche"
      v-model="sasAutoInspection2.cabinetDiplomeAffiche"
      :live="liveSasAutoInspection2(15549)"
    ></opq-catalogue>

    <opq-catalogue code="cabinet-absence" v-model="sasAutoInspection2.cabinetAbsence" :live="liveSasAutoInspection2(15550)"></opq-catalogue>

    <opq-catalogue code="cabinet-avis-ordre" v-model="sasAutoInspection2.cabinetAvisOrdre" :live="liveSasAutoInspection2(15551)"></opq-catalogue>

    <opq-memo
      code="cabinet-avis-ordre-commentaire"
      v-model="sasAutoInspection2.cabinetAvisOrdreCommentaire"
      :live="liveSasAutoInspection2(15552)"
      optional
    ></opq-memo>
  </v-form>
</template>

<script>
import FormSimple from "@/mixins/FormSimple"
import CataloguesHelper from "@/mixins/CataloguesHelpers"
export default {
  mixins: [FormSimple, CataloguesHelper],
  props: {
    sas: { type: Object }
  },

  computed: {
    sasAutoInspection1() {
      return this.sas.sasAutoIP1
    },

    sasAutoInspection2() {
      return this.sas.sasAutoIP2
    },

    estNonMembreLssss() {
      return this.estNon(this.sasAutoInspection2.membreLssss)
    }
  },

  methods: {
    liveSasAutoInspection1(cle) {
      return { endpoint: "/sas-auto-inspection-1/", cle: cle, fileId: this.sasAutoInspection1.id }
    },

    liveSasAutoInspection2(cle) {
      return { endpoint: "/sas-auto-inspection-2/", cle: cle, fileId: this.sasAutoInspection2.id }
    }
  }
}
</script>

<style>
</style>